export default __webpack_public_path__ + "static/media/wf-isf-perspectives-solar-projects_1164x584.b217632d.jpg";